/* eslint-disable no-return-await, no-console, no-param-reassign, no-trailing-spaces */
import axios from 'axios';
// import moment from 'moment';
import helper from '@/_libs/helper';

// const DATE_TODAY = moment().format('YYYY-MM-DD');

// const DATE_YESTERDAY = moment().subtract(1, 'days').format('YYYY-MM-DD');
// const DATE_3_DAYS_AGO = moment().subtract(3, 'days').format('YYYY-MM-DD');
// const DATE_LASTWEEK = moment().subtract(7, 'days').format('YYYY-MM-DD');

// const DATE_TOMORROW = moment().add(1, 'days').format('YYYY-MM-DD');

const COL_TYPE = {
  PermissionLevels: 100,
  ActivationStatus: 101,
  LoginUrl: 102,
};

const PERMISSION_LEVELS = {
  SALE: 0,
  CS: 1,
  APPROVER: 2,
  ADMIN: 3,
};

const MOCK = {
  permissions: {
    staffs: [
      {
        username: 'diana',
        firstName: 'ปิยปราชญ์',
        lastName: 'วัจนะประสิทธิ์',
        permissonLevel: PERMISSION_LEVELS.SALE,
        enabled: true,
        loginUrl: 'dhdfnkmnvuyfaskovpfbfbm.htp.kjo.com',

        imgSrc: 'http://placekitten.com/128/128',
        id: '011023',
        code: '08594111',
        zone: 'NE',

        email: 'someone@example.com',
        phone: '08594333211',
      },
      {
        username: 'campos',
        firstName: 'ธายุกร',
        lastName: 'ธรรมสรณ์',
        permissonLevel: PERMISSION_LEVELS.SALE,
        enabled: false,
        loginUrl: 'dhdfnkmnvuyfaskovpfbfbm.htp.kjo.com',

        imgSrc: 'http://placekitten.com/256/256',
        id: '011023',
        code: '08594111',
        zone: 'NE',

        email: 'someone@example.com',
        phone: '08594333211',
      },
      {
        username: 'Thepthep',
        firstName: 'ธนากร',
        lastName: 'อรรถพันธ์',
        permissonLevel: PERMISSION_LEVELS.SALE,
        enabled: false,
        loginUrl: 'dhdfnkmnvuyfaskovpfbfbm.htp.kjo.com',

        imgSrc: 'http://placekitten.com/200/200',
        id: '011023',
        code: '08594111',
        zone: 'NE',

        email: 'someone@example.com',
        phone: '08594333211',
      },
      {
        username: 'Suthat009',
        firstName: 'ชนารดี',
        lastName: 'พลลภัตม์',
        permissonLevel: PERMISSION_LEVELS.CS,
        enabled: true,
        loginUrl: 'dhdfnkmnvuyfaskovpfbfbm.htp.kjo.com',

        imgSrc: 'http://placekitten.com/96/96',
        id: '011023',
        code: '08594111',
        zone: 'NE',

        email: 'someone@example.com',
        phone: '08594333211',
      },
      {
        username: 'Eak98',
        firstName: 'พลกฤต',
        lastName: 'กานต์มณี',
        permissonLevel: PERMISSION_LEVELS.ADMIN,
        enabled: true,
        loginUrl: 'dhdfnkmnvuyfaskovpfbfbm.htp.kjo.com',

        imgSrc: 'http://placekitten.com/100/100',
        id: '011023',
        code: '08594111',
        zone: 'NE',

        email: 'someone@example.com',
        phone: '08594333211',
      },
    ],
  },
};

const mapPermissionLevel = (data) => {
  switch (data.roles[0].name) {
    case 'sales':
      return PERMISSION_LEVELS.SALE;
    case 'cs':
      return PERMISSION_LEVELS.CS;
    case 'approver':
      return PERMISSION_LEVELS.APPROVER;
    case 'admin':
      return PERMISSION_LEVELS.ADMIN;
    default:
      return -1;
  }
  // if (data.roles && data.roles[0]) {
  //   return data.roles[0].name;
  // }
  // return '-';
};

const permissions = {
  // Permission
  async getUserAreas(allowSelectAll = false) {
    return await helper.call('admin.permissions.userAreas', {
      success: true,
      data: [],
    }, async () => {
      const res = await axios(helper.path('auth'));
      const AREAS = [
        {
          value: '',
          text: allowSelectAll === false ? 'เลือกเขต' : 'ทุกเขต',
          disabled: allowSelectAll === false,
        },
      ];
      res.data.forEach((elm) => {
        const area = {  
          value: elm.code,
          text: allowSelectAll === false ? elm.name : `เขต ${elm.name}`,
        };
        // AREAS[elm.code] = area;
        AREAS.push(area);
      });
      // AREAS.splice(0, 0, { value: '', text: 'เลือกเขต' });

      res.data = AREAS;
      return res;
    });
  },
  async staffsList(page = 1, filterSearch, filterRole) {
    return await helper.call('admin.permissions.staffsList', {
      success: true,
      data: MOCK.permissions.staffs,
    }, async () => {
      let res = await axios(helper.path('user'), {
        params: {
          'page[number]': page,
          query: !filterSearch ? undefined : filterSearch,
          role: !filterRole ? undefined : filterRole,
        },
      });
      res = helper.dataMap(res, elm => ({
        ...elm,
        permissionLevel: mapPermissionLevel(elm),
        active: elm.active === 1,
        
        zone: elm.area ? elm.area.code : '',
        imgSrc: elm.profile_image_path,
        
        employeeId: elm.employee_id,
        areaCode: elm.area ? elm.area.code : '',
        userRole: elm.roles && elm.roles[0] ? elm.roles[0].name : '',
      }));
      
      // sort by permissionLevel (high -> low)
      res.data.data = res.data.data.sort((a, b) => b.permissionLevel - a.permissionLevel);
      return res;
    });
  },
  async getToken(userId) {
    return await helper.call('admin.getToken', {
      success: true,
      data: {},
    }, async () => {
      const res = await axios(helper.path(`saletoken/${userId}`));
      return res;
    });
  },
  async revokeToken(userId) {
    return await helper.call('admin.revokeToken', {
      success: true,
      data: {},
    }, async () => {
      const res = await axios.delete(helper.path(`saletoken/${userId}`));
      return res;
    });
  },
  async generateToken(userId) {
    return await helper.call('admin.generateToken', {
      success: true,
      data: {},
    }, async () => {
      const res = await axios.post(helper.path(`saletoken/${userId}`));
      return res;
    });
  },
  async updateUser(userId, user) {
    return await helper.call('admin.permissions.updateUser', {
      success: true,
      data: [],
    }, async () => {
      user = {
        ...user,
      };
      const res = await axios.post(helper.path(`user/${userId}`), user);
      // const res = await axios.post(helper.path(`user/${userId}`), user, { 
      //   headers: {
      //     'Content-Type': 'multipart/form-data',
      //   },
      // });
      return res;
    });
  },
  async updateUserWithPic(userId, formData) {
    return await helper.call('admin.permissions.updateUser', {
    }, async () => await axios.post(helper.path(`user/${userId}`),
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }));
  },
  async newUser(formData) {
    // return await helper.call('admin.permissions.newUser', {
    //   success: true,
    //   data: [],
    // }, async () => {
    //   user = {
    //     ...user,
    //   };
    //   const res = await axios.post(helper.path('user'), user);
    //   return res;
    // });
    return await helper.call('admin.permissions.newUser', {
    }, async () => await axios.post(helper.path('user'),
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }));
  },

  PERMISSION_LEVELS,
  COL_TYPE,
};

export default permissions;
